import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { color, fontSize } from 'theme';

const AdsContainer = styled.div`
  width: 100%;
  padding: 10px;
  background-color: ${color.backgroundDark};
  border-top: 1px solid ${color.greyText};
  text-align: center;

  @media (min-width: 768px) {
    padding: 20px;
  }
`;

const AdsPlaceholder = styled.div`
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed ${color.greyText};
  border-radius: 4px;
  color: ${color.lightGrey};
  font-size: ${fontSize.small};

  @media (min-width: 768px) {
    min-height: 90px;
    font-size: ${fontSize.regular};
  }
`;

export const Ads = () => {
  const configData = useSelector((state) => state.configuration?.data);
  // Handle both string '1' and integer 1 from API
  const isAdsEnabled =
    configData?.ads_enabled === 1 || configData?.ads_enabled === '1';

  if (!isAdsEnabled) {
    return null;
  }

  return (
    <AdsContainer>
      <AdsPlaceholder>
        {/* TODO: Integrate ad network (Google AdSense, etc.) */}
        Advertisement Placeholder
      </AdsPlaceholder>
    </AdsContainer>
  );
};
